import DesCatalogCarouselViewModel from 'viewmodel/DesCatalogCarouselViewModel'
import {DesBaseCatalogAcc} from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';

export default class DesCatalogCarousel extends DesBaseCatalogAcc {
    constructor() {
        super(DesCatalogCarouselViewModel);
    }

    get accsessionid() {
        this.getAttribute('accsessionid');
    }

    get allViewersSRC() {
        return this.getAttribute('allViewersSRC');
    }

    get provider() {
        return this.getAttribute('provider');
    }

    get catalogspaceid() {
        return this.getAttribute('catalogspaceid');
    }

    get disableCarousel() {
        return this.getAttribute(DesAccConstants.DISABLE_CAROUSEL);
    }

    getProps() {
        return {
            allViewersSRC: this.allViewersSRC,
            accsessionid : this.accsessionid,
            provider : this.provider,
            catalogspaceid: this.catalogspaceid,
            disablecarousel: this.disableCarousel
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes,'accsessionid', 'allViewersSRC', 'provider', 'catalogspaceid', DesAccConstants.DISABLE_CAROUSEL];
    }
}

if (!window.customElements.get('des-catalog-carousel')) {
    window.customElements.define('des-catalog-carousel', DesCatalogCarousel);
}
